import { createGlobalStyle } from 'styled-components';
import { enhancedButtonContrast } from './contrastUtils';

const GlobalStyles = createGlobalStyle`
  /* Styles pour les boutons avec contraste amélioré */
  .enhanced-contrast-button {
    ${enhancedButtonContrast}
  }
  
  /* Styles pour garantir la visibilité des textes dans les modales sur tous les appareils */
  .modal-title, 
  .modal-text,
  .modal-address,
  .modal-button {
    color: #000000 !important;
    text-shadow: 0 0 1px rgba(255,255,255,0.5);
  }
  
  /* Styles spécifiques pour les appareils Samsung */
  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    /* Cette règle cible spécifiquement les navigateurs WebKit (Chrome, Safari, Samsung Internet) */
    .modal-content * {
      color: #000000 !important;
    }
  }
`;

export default GlobalStyles;

